import type { GetTweets200PageAllOfThreeContentItemBasicInfoAllOf } from './getTweets200PageAllOfThreeContentItemBasicInfoAllOf';
import type { GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwo } from './getTweets200PageAllOfThreeContentItemBasicInfoAllOfTwo';

export type GetTweets200PageAllOfThreeContentItemBasicInfo = GetTweets200PageAllOfThreeContentItemBasicInfoAllOf & GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwo;
